import { render, staticRenderFns } from "./StudentAccountsList.vue?vue&type=template&id=5702c544"
import script from "./StudentAccountsList.vue?vue&type=script&lang=js"
export * from "./StudentAccountsList.vue?vue&type=script&lang=js"
import style0 from "./StudentAccountsList.vue?vue&type=style&index=0&id=5702c544&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports